var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "error-page" }, [
    _c("div", { staticClass: "container" }, [
      _vm._m(0),
      _vm._v(" "),
      _vm._m(1),
      _vm._v(" "),
      _c("div", { staticClass: "btns" }, [
        _c("div", { staticClass: "row justify-content-center" }, [
          _c(
            "div",
            { staticClass: "col-md-5" },
            [
              _c(
                "router-link",
                {
                  class: "btn btn-green btn-full small",
                  attrs: { to: { name: "index" } }
                },
                [
                  _vm._v(
                    "\n                        to main\n                    "
                  )
                ]
              )
            ],
            1
          )
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "img p-center" }, [
      _c("img", { attrs: { src: "/img/404.svg", alt: "" } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content" }, [
      _c("h1", { staticClass: "relawayBold p-black p-center p-title" }, [
        _c("b", [_vm._v("Oops! Page not found...")])
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "Raleway p-center min-med" }, [
        _vm._v("You should try to refresh this page or return to the Home page")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }